/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import { Provider } from 'react-redux';

import store from './store';

/**
 * Wraps the given component in the global store provider.
 *
 * @param Component Component to wrap.
 * @return {function(Object): *} Wrapped component.
 */
export default function withProvider(Component) {
  return (props = {}) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Provider store={store}><Component {...props} /></Provider>
  );
}
